export const isFirstStep = (index: number, pathName: string) => {
  return index === 0 && pathName.includes('intro/1');
};

export const isLastStep = (index: number, childrenCount: number) => {
  return childrenCount === index + 1;
};

export const getButtonText = (
  index: number,
  childrenCount: number,
  startText: string,
  nextText: string,
  submitText: string,
  pathName: string
) => {
  const firstStep = isFirstStep(index, pathName);
  const lastStep = isLastStep(index, childrenCount);
  const nextOrSubmitText = lastStep ? submitText : nextText;
  return firstStep ? startText : nextOrSubmitText;
};

export const showStepper = (pathname: string): boolean => {
  // expenses pages
  if (pathname.includes('oppfolging')) {
    return false;
  }
  return true;
};
